import React, { useState, useEffect, useCallback } from 'react';
import {
  DragDropContext,
  Droppable,
  Draggable,
  DropResult,
} from 'react-beautiful-dnd';
import { FiPlus, FiTrash, FiGrid } from 'react-icons/fi';
import Swal from 'sweetalert2';

import api from '../../../services/api'; // Ajuste o caminho se necessário
import { Container, Header, PostList, PostItem, DragHandle } from './styles';
import { ILinkedInPost } from '~/interfaces/ILinkedInPost';
import AdminHeader from '~/components/Admin/Header';
import Footer from '~/components/Footer';

const ManageBlog: React.FC = () => {
  const [posts, setPosts] = useState<ILinkedInPost[]>([]);
  const [loading, setLoading] = useState(true);

  // Efeito para buscar os dados da API quando o componente montar
  useEffect(() => {
    // --- ALTERAÇÃO 2: Carregando os dados falsos em vez de chamar a API ---
    // setPosts(FAKE_INITIAL_POSTS);
    // setLoading(false);

    // INTEGRAÇÃO COM API (COMENTADO)
    api.get<ILinkedInPost[]>('api/linkedin-posts').then((response) => {
      setPosts(response.data);
      setLoading(false);
    });

    // ----------------------------------------------------------------------
  }, []);

  const handleAddPost = useCallback(async () => {
    const { value: url } = await Swal.fire({
      title: 'Adicionar Novo Post',
      input: 'url',
      inputLabel: 'URL do post no LinkedIn',
      inputPlaceholder: 'https://www.linkedin.com/feed/update/...',
      showCancelButton: true,
      confirmButtonText: 'Adicionar',
      cancelButtonText: 'Cancelar',
      inputValidator: (value) => {
        if (!value) {
          return 'Você precisa inserir uma URL!';
        }
        return null;
      },
    });

    if (url) {
      // --- ALTERAÇÃO 3: Lógica fake para adicionar post ---
      // const newPost: ILinkedInPost = {
      //   id: `post-${new Date().getTime()}`, // Gera um ID único simples
      //   linkedinUrl: url,
      //   position: posts.length, // Adiciona ao final da lista
      // };

      // setPosts((currentPosts) => [...currentPosts, newPost]);
      // Swal.fire('Sucesso!', 'Post adicionado com sucesso.', 'success');
      // ------------------------------------------------------

      // INTEGRAÇÃO COM API (COMENTADO)
      try {
        const response = await api.post<ILinkedInPost>('api/linkedin-posts', {
          linkedinUrl: url,
        });
        setPosts((currentPosts) => [...currentPosts, response.data]);
        Swal.fire('Sucesso!', 'Post adicionado com sucesso.', 'success');
      } catch (error) {
        Swal.fire('Erro!', 'Não foi possível adicionar o post.', 'error');
      }
    }
  }, []); // Adicionamos 'posts.length' como dependência

  const handleDeletePost = useCallback(async (id: string) => {
    Swal.fire({
      title: 'Você tem certeza?',
      text: 'Esta ação não pode ser revertida!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sim, deletar!',
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        // --- ALTERAÇÃO 4: Lógica fake para deletar post ---
        // setPosts((currentPosts) =>
        //   currentPosts.filter((post) => post.id !== id)
        // );
        // Swal.fire('Deletado!', 'O post foi removido.', 'success');
        // --------------------------------------------------

        // INTEGRAÇÃO COM API (COMENTADO)
        try {
          await api.delete(`api/linkedin-posts/${id}`);
          setPosts((currentPosts) =>
            currentPosts.filter((post) => post.id !== id)
          );
          Swal.fire('Deletado!', 'O post foi removido.', 'success');
        } catch (error) {
          Swal.fire('Erro!', 'Não foi possível remover o post.', 'error');
        }
      }
    });
  }, []);

  // Função chamada ao final de uma ação de arrastar
  const onDragEnd = useCallback(
    async (result: DropResult) => {
      const { destination, source } = result;

      if (!destination) return;
      if (
        destination.droppableId === source.droppableId &&
        destination.index === source.index
      ) {
        return;
      }

      const reorderedPosts = Array.from(posts);
      const [movedItem] = reorderedPosts.splice(source.index, 1);
      reorderedPosts.splice(destination.index, 0, movedItem);

      // Atualiza o estado local (isso já era feito, então mantemos)
      setPosts(reorderedPosts);

      // --- ALTERAÇÃO 5: A chamada para salvar a nova ordem na API foi comentada ---

      // INTEGRAÇÃO COM API (COMENTADO)
      try {
        const orderedIds = reorderedPosts.map((post) => post.id);
        await api.patch('api/linkedin-posts/order', { orderedIds });
      } catch (error) {
        Swal.fire(
          'Erro!',
          'Não foi possível salvar a nova ordem. Revertendo.',
          'error'
        );
        // Em um cenário real, reverteríamos o estado se a API falhasse.
        // Aqui, como é fake, não precisamos nos preocupar.
        // setPosts(posts); // Reverte
      }
      // --------------------------------------------------------------------------
    },
    [posts]
  );

  if (loading) {
    return (
      <Container>
        <p style={{ marginTop: '10dvh' }}>Carregando posts...</p>
      </Container>
    );
  }

  return (
    <>
      <AdminHeader />
      <Container>
        <Header>
          <h1>Gerenciar Blog</h1>
          <button type="button" onClick={handleAddPost}>
            <FiPlus />
            Adicionar Post
          </button>
        </Header>

        {/* // CÓDIGO NOVO E CORRIGIDO */}

        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="linkedin-posts">
            {/* Renomeamos para 'droppableProvided' para evitar conflito */}
            {(droppableProvided) => (
              <PostList
                {...droppableProvided.droppableProps}
                ref={droppableProvided.innerRef}
              >
                {posts.map((post, index) => (
                  <Draggable key={post.id} draggableId={post.id} index={index}>
                    {/* Renomeamos este para 'draggableProvided' */}
                    {(draggableProvided, snapshot) => (
                      <PostItem
                        ref={draggableProvided.innerRef}
                        {...draggableProvided.draggableProps}
                        isDragging={snapshot.isDragging}
                      >
                        {/* O dragHandleProps vem do draggableProvided */}
                        <DragHandle {...draggableProvided.dragHandleProps}>
                          <FiGrid size={24} />
                        </DragHandle>
                        <a
                          href={post.linkedinUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {post.linkedinUrl}
                        </a>
                        <button
                          type="button"
                          onClick={() => handleDeletePost(post.id)}
                        >
                          <FiTrash size={20} />
                        </button>
                      </PostItem>
                    )}
                  </Draggable>
                ))}
                {/* O placeholder vem do droppableProvided */}
                {droppableProvided.placeholder}
              </PostList>
            )}
          </Droppable>
        </DragDropContext>
      </Container>
      <Footer message="" />
    </>
  );
};

export default ManageBlog;
